import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\'dashboard-item\'\n  style={{layout-css-var x=@x y=@y height=@height width=@width}}\n  data-test-dashboard-item\n  ...attributes\n>\n  {{yield}}\n</div>")